import { render, staticRenderFns } from "./CampusGradeCreate.vue?vue&type=template&id=a49732d8"
import script from "../../controllers/campus_grade/campus-grade-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/campus_grade/campus-grade-create.js?vue&type=script&lang=js&external"
import style0 from "./CampusGradeCreate.vue?vue&type=style&index=0&id=a49732d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports